import React, { useState, useEffect } from "react";
import { BubbleMenu } from "@tiptap/react";
import {
  Settings, // Trigger Icon
  ArrowUpToLine,
  ArrowDownToLine,
  ArrowLeftToLine,
  ArrowRightToLine,
  Trash2,
  Columns,
  Rows,
} from "lucide-react";

const TableBubbleMenu = ({ editor }) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (editor && !editor.isActive("table")) {
      setIsOpen(false);
    }
  }, [editor, editor?.state?.selection]);

  // Safety check hooks ke baad
  if (!editor) {
    return null;
  }

  const shouldShow = ({ editor }) => {
    return editor.isActive("table");
  };

  const handleAction = (action) => {
    action();
    setIsOpen(false);
  };

  return (
    <BubbleMenu
      editor={editor}
      tippyOptions={{ duration: 100, placement: "top" }}
      shouldShow={shouldShow}
      className="bubble-menu-dropdown-container"
    >
      <button
        type="button"
        className="dropdown-trigger-btn"
        onClick={() => setIsOpen(!isOpen)}
        title="Table Options"
      >
        <Settings size={16} />
        <span
          style={{ marginLeft: "6px", fontSize: "12px", fontWeight: "600" }}
        >
          Table Options
        </span>
      </button>

      {isOpen && (
        <div className="dropdown-list">
          <div className="dropdown-label">Columns</div>
          <button
            type="button"
            onClick={() =>
              handleAction(() => editor.chain().focus().addColumnBefore().run())
            }
          >
            <ArrowLeftToLine size={14} /> Add Left
          </button>
          <button
            type="button"
            onClick={() =>
              handleAction(() => editor.chain().focus().addColumnAfter().run())
            }
          >
            <ArrowRightToLine size={14} /> Add Right
          </button>
          <button
            type="button"
            onClick={() =>
              handleAction(() => editor.chain().focus().deleteColumn().run())
            }
            className="danger-text"
          >
            <Columns size={14} /> Delete Col
          </button>

          <div className="divider-h"></div>
          <div className="dropdown-label">Rows</div>
          <button
            type="button"
            onClick={() =>
              handleAction(() => editor.chain().focus().addRowBefore().run())
            }
          >
            <ArrowUpToLine size={14} /> Add Above
          </button>
          <button
            type="button"
            onClick={() =>
              handleAction(() => editor.chain().focus().addRowAfter().run())
            }
          >
            <ArrowDownToLine size={14} /> Add Below
          </button>
          <button
            type="button"
            onClick={() =>
              handleAction(() => editor.chain().focus().deleteRow().run())
            }
            className="danger-text"
          >
            <Rows size={14} /> Delete Row
          </button>

          <div className="divider-h"></div>
          <button
            type="button"
            onClick={() =>
              handleAction(() => editor.chain().focus().deleteTable().run())
            }
            className="danger-bg"
          >
            <Trash2 size={14} /> Delete Table
          </button>
        </div>
      )}
    </BubbleMenu>
  );
};

export default TableBubbleMenu;
